<template>
  <div class="back_baseInfo">
    <el-dialog
      width="820px"
      :close-on-click-modal="false"
      title="溯源参数污染分析"
      :visible.sync="dialogSuyuanVisible"
      :before-close="handleClose"
      
    >
      <el-form
      v-loading="loading"
       element-loading-text="拼命加载中"
        :model="form"
        :rules="rules"
        ref="ruleForm"
        size="mini"
        :inline-message="true"
      >
        <el-form-item label="标站SN" :label-width="formLabelWidth">
          <el-input :value="sn" disabled style="width: 140px"></el-input>&nbsp;({{gf_name}})
        </el-form-item>
        <el-form-item
          label="时间"
          :label-width="formLabelWidth"
          required
          prop="timeValue"
        >
          <el-date-picker
            style="width: 400px"
            v-model="form.timeValue"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="关注参数" :label-width="formLabelWidth">
          <el-checkbox-group v-model="form.checkParamList">
            <el-checkbox
              v-for="item in paramsList"
              :key="item.id"
              :label="item.value"
            
            >
            {{item.label}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item
          label="对比标站级别"
          :label-width="formLabelWidth"
          required
          prop="levels"
        >
          <!-- <el-input :value="level" style="width: 140px" disabled></el-input> -->
          <el-select v-model="form.levels" multiple placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="风向两侧污染来源微站选择范围"
          :label-width="formLabelWidth"
          required
          prop="windRange"
        >
          <el-input
            v-model.number="form.windRange"
            style="width: 140px"
          ></el-input>
          <span style="fontsize: 10px; color: #ccc"
            >(单位：度)输入范围：0≤n≤90的整数</span
          >
        </el-form-item>

        <el-form-item
          label="微站时间提前量"
          :label-width="formLabelWidth"
          required
          prop="advanceTime"
        >
          <el-input
            v-model.number="form.advanceTime"
            style="width: 140px"
          ></el-input>
          <span style="fontsize: 10px; color: #ccc">(单位：小时)输入范围：≥0的整数</span>
        </el-form-item>
        <el-form-item
          label="标站周边范围"
          :label-width="formLabelWidth"
          required
          prop="around"
        >
          <el-input v-model="form.around" style="width: 140px"></el-input>
          <span style="fontsize: 10px; color: #ccc"
            >(单位：千米)输入范围：≥0，最多保留五位小数</span
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')" :disabled='loading'>重置</el-button>
        <el-button type="primary" @click="submit" :disabled='loading'>确 定</el-button>
      </div>
      <BackInfo :tableData='backInfoData' :gf_name='gf_name' v-show="isShow" :emptyText='emptyText'></BackInfo>
    </el-dialog>
  </div>
</template>

<script>
import BackInfo from '@/components/suyuan/backInfo_table'
import { set_info_pollute } from "@/api/api";
import { paramsList } from "@/utils/common";

export default {
  components:{
    BackInfo
  },
  data() {
    var checkWindRange = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("数值不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value < 0 || value > 90) {
            callback(new Error("输入范围：0≤n≤90的整数"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    var checkAdvanceTime = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("数值不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value < 0) {
            callback(new Error("输入范围：≥0的整数"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    var checkAround = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("数值不能为空"));
      }
      setTimeout(() => {
        var reg = /^[0-9]+([.]{1}[0-9]{1,5})?$/;
        //注意这里value通过parsefloat转变了一次，变成了数值型，正则需要字符串所以需要再转成字符串
        var r = (value + '').match(reg);
        if (!r) {
          return callback(new Error("输入范围：≥0，最多保留5位小数"));
        } else {
          callback();
        }
      }, 100);
    };
    return {
      emptyText:'', //空数据时显示的文本内容
      isShow:false,//表格显隐
      backInfoData:[],
      pickerOptions: {
        shortcuts: [
         {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
            }
        ],
        disabledDate(time){
          return time.getTime()>Date.now()
        }
      },      
      form: {
        timeValue: [],
        checkParamList: ['pm25','pm10'],
        windRange: "",
        advanceTime: "",
        around: "",
        levels: [],
      },
      paramsList:paramsList,
      options: [
        {
          value: "国",
          label: "国",
        },
        {
          value: "省",
          label: "省",
        },
        {
          value: "市",
          label: "市",
        },
        {
          value: "街镇",
          label: "街镇",
        },
        {
          value: "其他",
          label: "其他",
        },
      ],
      loading:false,
      formLabelWidth: "120px",
      rules: {
        timeValue: [
          {
            required: true,
            message: "请选择日期时间",
            trigger: "blur",
          },
        ],
        levels: [
          {
            required: true,
            message: "请至少选择一个对比标站级别",
            trigger: "change",
          },
        ],
        windRange: [
          {
            required: true,
            // message: "请输入风向两侧污染来源微站选择范围",
            validator: checkWindRange,
            trigger: "blur",
          },
        ],
        advanceTime: [
          {
            required: true,
            // message: "请输入微站时间提前量",
            validator: checkAdvanceTime,
            trigger: "blur",
          },
        ],
        around: [
          {
            required: true,
            //  message: "请输入标站周边范围",
            validator: checkAround,
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: ["dialogSuyuanVisible", "sn", "level","gf_name"],
  watch: {
    level(newValue, oldValue) {
      console.log('newValue:',newValue);
      this.form.levels = [newValue];
    },
    
  },
  methods: {
    // 重置
   resetForm(formName) {
        this.$refs[formName].resetFields();
        this.form.checkParamList=['pm25','pm10']
      },
    handleClose() {
      //清空表单
      this.form.timeValue=[]
      this.form.checkParamList=[]
      this.form.windRange=''
      this.form.advanceTime=''
      this.form.around=''
      this.form.levels=[]
      this.$refs.ruleForm.resetFields()
      this.backInfoData=[]
      this.isShow=false
      this.$emit("parentControlClose");
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          //   let val1=this.$moment(this.form.timeValue[0]).format('YYYY-MM-DD HH:mm:ss')
          //   let val2=this.$moment(this.form.timeValue[1]).format('YYYY-MM-DD HH:mm:ss')
          //  this.form.timeValue[0]=val1
          //  this.form.timeValue[1]=val2
          this.backInfoData=[]
          this.emptyText=''
          this.form.sn_gf=this.sn
          this.form.around=parseFloat(this.form.around)
          this.loading=true
         set_info_pollute(this.form)
            .then((res) => {
              console.log(res);
              if(res.data.data=='error'){
                 this.emptyText='程序运行异常'
                 this.loading=false
                 this.isShow=true
                 return
              }
              this.backInfoData=res&&res.data&&res.data.data

              console.log(this.backInfoData);
              this.emptyText='暂无污染信息'
              this.loading=false
              this.isShow=true
            })
            .catch((err) => {
              this.loading=false
              this.isShow=true
              console.log(err);
              this.emptyText='程序运行异常~'
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //调接口
      // this.$emit("parentControlClose");
    },
  },
};
</script>

<style scoped>

.el-form-item {
  margin-bottom: 5px !important;
}
.el-date-editor {
  width: 335px !important;
}
.el-checkbox {
  width: 65px !important;
}
.el-form--label-top .el-form-item__label {
  padding: 0 !important;
}
/* .el-form-item__label {
  height: 35px !important;
} */

</style>


// WEBPACK FOOTER //
// src/components/suyuan/index.vue